export default __webpack_public_path__ + "static/media/workouttimes@2x.a072f981.jpg";